import { DEFAULT_DESIGN_SYSTEM_DARK_THEME, DesignSystemTheme } from '../constants';

export const designSystem: DesignSystemTheme = { ...DEFAULT_DESIGN_SYSTEM_DARK_THEME };
